import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Divider,
  IconButton,
  Tooltip,
  Button,
  InputBase,
} from "@mui/material";
import { UseB2BOrderReport } from "./UseB2BOrderReport";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter, toMoney } from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
import { moment } from "jalali-moment";
import FilterSearch from "../../Marketing/B2BOrders/FilterSearch";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

export default function B2BOrderReport(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const { myPc, updatePage, updateSort, setScrollTo, refresh, goToFirstPage } =
    UseMyPC();
  const { GetB2BOrderReport } = UseB2BOrderReport();
  const [reportRes, setReportRes] = useState();
  const [add, setAdd] = useState("");
  const [openDialoge, setOpenDialoge] = useState({
    show: false,
    model: undefined,
  });
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const { toSolar } = require("jdate-convert");

  const today = toSolar(new Date().toJSON().slice(0, 10));

  const [state, setState] = useState({
    year: today ? Number(today.slice(0, 4)) : 1403,
    month: today ? Number(today.slice(5, 7)) : "",
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    setProgress(true);
    GetB2BOrderReport(
      myPc,
      search,
      state.year,
      state.month,
      (callback) => {
        setReportRes(callback);
      },
      true
    );
  }, [myPc, state]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const columns = [
    {
      field: "rowIndex",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "mobile",
      headerName: " موبایل",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "fullName",
      headerName: "نام",
      width: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.fullName}
          </Typography>
        );
      },
    },

    {
      field: "orgenizeName",
      headerName: "نام سازمان",
      width: 180,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.orgenizeName}
          </Typography>
        );
      },
    },
    {
      field: "totalCost",
      headerName: "مجموع خرید",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.totalCost ? toMoney(cellValues.row.totalCost) : 0}
          </Typography>
        );
      },
    },
    {
      field: "offerPercent",
      headerName: "درصد کمیسیون",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.offerPercent ? cellValues.row.offerPercent : 0}
          </Typography>
        );
      },
    },
    {
      field: "totalOffer",
      headerName: "کمیسیون",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.totalOffer ? toMoney(cellValues.row.totalOffer) : 0}
          </Typography>
        );
      },
    },
    {
      field: "walletDate",
      headerName: "تسویه",
      width: 70,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.walletDate ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 200,
      sortable: false,
      headerAlign: "center",
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "گزارشات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/deliveryreport" }],
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <FilterSearch setState={setState} state={state} />
        <Box
          sx={{
            flexGrow: 1,
          }}
        >
          {reportRes ? (
            <DataGrid
              className="ltr-grid"
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              pageSize={
                reportRes && reportRes.pageCondition
                  ? reportRes.pageCondition.pageCount
                  : 1
              }
              rows={reportRes ? reportRes.items : []}
              paginationMode="server"
              page={
                reportRes && reportRes.pageCondition
                  ? reportRes.pageCondition.page - 1
                  : 1
              }
              onPageChange={(page) => {
                updatePage(page + 1);
              }}
              rowCount={
                reportRes && reportRes.pageCondition
                  ? reportRes.pageCondition.totalItemCount
                  : 1
              }
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              componentsProps={{
                pagination: {
                  scrollTo: myPc.scrollTo,
                  isLtr: true,
                  nofab: true,
                  rowCount:
                    reportRes && reportRes.pageCondition
                      ? reportRes.pageCondition.totalItemCount
                      : "",
                },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: deCapitalizeFirstLetter(myPc.sortColumn),
                      sort: deCapitalizeFirstLetter(myPc.sortOrder),
                    },
                  ],
                },
                pagination: {
                  page: myPc.page,
                },
              }}
              onSortModelChange={(model) => {
                updateSort(
                  model[0].field,
                  model[0].sort == "asc" ? "asc" : "desc"
                );
              }}
              sortingOrder={["desc", "asc"]}
              sortingMode="server"
              sx={{
                "& .MuiDataGrid-cell:focus": {
                  outline: "none",
                },
                "&  .MuiDataGrid-columnHeader:focus-within": {
                  outline: "none",
                },
                "&  .MuiDataGrid-cell:focus-within ": {
                  outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                },
                "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
                  {
                    outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                  },
                "& .MuiDataGrid-cell:hover": {
                  opacity: "80%",
                  cursor: "pointer",
                },
                "& .MuiDataGrid-virtualScrollerRenderZone": {
                  width: "100% !important",
                },
              }}
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
        </Box>
      </Box>
    </Detail>
  );
}
